import {ReactComponent as BillaloMiniSvg} from "svg/billalo-mini.svg"
export const BillaloMini: React.FC<
React.SVGProps<SVGSVGElement>
> = ({ ...attributes }) => {
  
  return (<BillaloMiniSvg fill="#0062FF" {...attributes}/>
  );
};
export default BillaloMini;
